import Button, { CustomButtonProps } from 'components/Basic/Button';
import { MouseEventHandler, ReactNode, useState } from 'react';
import { getToolModeHandlers } from '../../ToolRegistry';
import { selectActiveAction, selectNeedCancelConfirmation } from 'store/selectors/toolSelector';
import ConfirmationModal from 'components/Basic/Modal/Confirmation';
import { useDispatch, useSelector } from 'react-redux';
import { setCancelModalOpen } from 'store/slices/ToolSlice';

type ToolCancelButtonProps = CustomButtonProps & {
	label?: ReactNode;
	showIcon?: boolean;
};
export function ToolCancelButton(props: ToolCancelButtonProps){
	const action = useSelector(selectActiveAction);
	const needConfirmation = useSelector(selectNeedCancelConfirmation);
	const [showConfirm, setShowConfirm] = useState(false);
	const dispatch = useDispatch();

	if(!action) return null;

	let handlers = getToolModeHandlers(action);
	const shouldShowIcon = props.showIcon || !props.label;

	const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
		// custom click hadnler if any otherwise call handler for the mode.
		if (props.onClick) {
			props.onClick(e);
			return;
		}
		handlers = getToolModeHandlers(action);
		if (needConfirmation) {
			dispatch(setCancelModalOpen({isOpen: true}));
			setShowConfirm(true);
		} else {
			handlers?.cancel?.();
		}
	};

	const confirmCancel = () => {
		handlers = getToolModeHandlers(action);
		handlers?.cancel?.();
		setShowConfirm(false);
		dispatch(setCancelModalOpen({isOpen: false}));
	};

	return(
		<>
			<Button 
				id={props.id} 
				onClick={handleClick} 
				disabled={props.disabled}
				className={`cancel-btn ${props.className}`}
			>
				{shouldShowIcon && (
					<svg
						width="15"
						height="15"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							id="cancel-path"
							d="M0.947266 0.947266L14.2631 14.2631M14.2631 0.947266L0.947265 14.2631"
							stroke={props.className === 'strip-cancel'? '#989898':'var(--iconMutedColor)'}
							strokeWidth="1.6"
							strokeLinecap="round"
						/>
					</svg>
				)}
				{props.label}
			</Button>

			<ConfirmationModal
				open={showConfirm}
				message={handlers?.cancelConfirmMessage || 'Are you sure you want to discard changes?'}
				onConfirm={confirmCancel}
				onCancel={() => {setShowConfirm(false); dispatch(setCancelModalOpen({isOpen: false}));}}
			/>
		</>
		
	);
}
